import AuthStore from './AuthStore';
import ConstantStore from './ConstantStore';
import UserStore from './UserStore';
var stores = {
    auth: new AuthStore(),
    user: new UserStore(),
    constant: new ConstantStore()
};
export default stores;



//////////////////
// WEBPACK FOOTER
// ./src/stores/stores.ts
// module id = 78
// module chunks = 0